<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <button
        type="button"
        class="ticket-priority-chip"
        v-bind="attrs"
        v-on="disabled ? {} : on"
        :disabled="disabled"
        :style="{ color: meta.color, borderColor: meta.color }"
      >
        <span>{{ $t(meta.labelKey) }}</span>
        <v-icon x-small :color="meta.color">mdi-chevron-down</v-icon>
      </button>
    </template>
    <v-list dense class="ticket-priority-menu py-1">
      <v-list-item
        v-for="item in priorities"
        :key="item.value"
        class="ticket-priority-menu-item"
        :input-value="item.value === meta.value"
        @click="$emit('input', item.value)"
      >
        <v-list-item-title :style="{ color: item.color }">
          {{ $t(item.labelKey) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  TICKET_PRIORITIES,
  getTicketPriorityMeta,
} from "@/views/dashboard/pages/ticket/ticketPriorities";

export default {
  name: "TicketPrioritySelect",
  props: {
    value: {
      type: [String, Number],
      default: "normal",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      priorities: TICKET_PRIORITIES,
    };
  },
  computed: {
    meta() {
      return getTicketPriorityMeta(this.value);
    },
  },
};
</script>

<style scoped>
.ticket-priority-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 28px;
  padding: 0 8px 0 10px;
  border: 1px solid;
  border-radius: 4px;
  background: #fff;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}
.ticket-priority-chip:disabled {
  opacity: 0.55;
  cursor: default;
}
.ticket-priority-menu-item {
  min-height: 32px !important;
}
.theme--dark .ticket-priority-chip {
  background: transparent;
}
</style>
